// extracted by mini-css-extract-plugin
export default {"starContainer":"starRating_starContainer__9JLdo"};